
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ProformaExpenseService } from '../proforma-expense.service';
import { ProformaExpense } from '../proforma-expense';

@Component({
    selector: 'app-proforma-expense',
    templateUrl: './proforma-expense.component.html',
    styleUrls: ['./proforma-expense.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ProformaExpenseComponent implements OnInit {

	proformaId: any;
	proformaIdRequired: any;
	proformaList: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private proformaExpenseService: ProformaExpenseService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.proformaId = data.proformaId,
			this.proformaExpense = data.proformaExpense,
			this.proformaExpenseId = data.proformaExpense?.proformaExpenseId;
			this.expenseFreqs = proformaExpenseService.expenseFreqs;
			this.feeTypes = proformaExpenseService.feeTypes;
			//this.expenseFreqs = proformaExpenseService.expenseFreqs;

	}

	@Input() proformaExpense: ProformaExpense;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	proformaExpenseId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	expenseFreqs: any;
	feeTypes: any;

	validationMessages = {
		'proformaExpenseId': [],
		'feeType': [{ type: 'required', message: 'Fee type Required' }],
		'name': [{ type: 'required', message: 'Name Required' }],
		'description': [],
		'quantity': [{ type: 'required', message: 'Quantity Required' }],
		'expenseAmnt': [],
		'expensePct': [],
		'expenseFreq': [{ type: 'required', message: 'Freq Required' }],
		'proformaId':[] //parent id here

	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.fetchProformaExpense();
		this.formBuild();

		// if we were passed the whole proformaExpense object
		if (this.proformaExpense) {
			this.proformaExpenseId = this.proformaExpense.proformaExpenseId;
			this.fixDates();
			this.form1.patchValue(this.proformaExpense);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.proformaExpenseId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			//Update percetange to null/undefined if value is zero
			if(this.form1.value.expensePct != undefined && this.form1.value.expensePct == 0) {
				this.form1.value.expensePct = undefined;
			}
			if(this.form1.value.expenseAmnt != undefined && this.form1.value.expensePct != undefined) {
				this.formAlert = 'Select either dollar or percent value, not both';
				return;
			}
			if(this.form1.value.expenseAmnt == undefined && this.form1.value.expensePct == undefined) {
				this.formAlert = 'Select either dollar or percent value';
				return;
			}

			this.form1.value.proformaId = this.proformaId;
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.proformaExpenseService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.proformaExpense = res.data.proformaExpense;
						this.proformaExpenseId = this.proformaExpense.proformaExpenseId;
						this.doAdd.emit(this.proformaExpense);
					},
					(err: any) => {
						console.log('proformaExpense-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	increasePercentage(percentagefield) {
		let updatedValue = this.form1.value[percentagefield] + 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield){
		let updatedValue = this.form1.value[percentagefield] - 0.01;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}

	formUpdate() {
		console.log('proformaExpense: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			//Update percetange to null/undefined if value is zero
			if(this.form1.value.expensePct != undefined && this.form1.value.expensePct == 0) {
				this.form1.value.expensePct = undefined;
			}
			if(this.form1.value.expenseAmnt != undefined && this.form1.value.expensePct != undefined) {
				this.formAlert = 'Select either dollar or percent value, not both';
				return;
			}
			if(this.form1.value.expenseAmnt == undefined && this.form1.value.expensePct == undefined) {
				this.formAlert = 'Select either dollar or percent value';
				return;
			}
			this.formLoading = true;
			this.form1.value.proformaExpenseId = this.proformaExpenseId;
			this.proformaExpenseService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.proformaExpense = res.data.proformaExpense;
						this.doUpdate.emit(this.proformaExpense);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.proformaExpenseService.delete(this.proformaExpense.proformaExpenseId)
				.subscribe(
					(res: any) => {
						console.log('proformaExpense-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.proformaExpense);
					},
					(err: any) => {
						console.log('proformaExpense-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			proformaExpenseId: [this.proformaExpenseId],
			feeType: ['', Validators.required],
			name: ['', Validators.required],
			description: [],
			quantity: [],
			expenseAmnt: [],
			expensePct: [],
			expenseFreq: ['', Validators.required],
			proformaId:[this.proformaId]

		});
	}
	fixDates() {
	}
	selectProformaExpense(){
		this.proformaIdRequired = false;
	}
	fetchProformaExpense() {
		try {
			this.proformaExpenseService.findAll()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.proformaList = res.data.proformas;
						return this.proformaList;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}
}
